var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnLang = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#en-lang_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#en-lang_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M-1 1h18v14H-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m1.11 1 6.862 5.28L14.806 1H17v1.808L10.25 8.03 17 13.221V15h-2.25L8 9.78 1.278 15H-1v-1.75l6.722-5.192L-1 2.867V1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M10.925 9.196 17 13.833V15L9.378 9.196zm-5.175.583.169 1.021-5.4 4.2H-1zM17 1v.087L9.997 6.572l.056-1.283L15.593 1zM-1 1l6.722 5.133H4.034L-1 2.225z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.778 1v14h4.5V1zM-1 5.667v4.666h18V5.667z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M-1 6.63v2.8h18v-2.8zM6.678 1v14h2.7V1z"
})))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  x: 0.5,
  y: 0.5,
  stroke: "#000",
  strokeOpacity: 0.06,
  rx: 7.5
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "en-lang_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  x: 1,
  y: 1,
  fill: "#fff",
  rx: 7
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "en-lang_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-1 1h18v14H-1z"
})))));
export default SvgEnLang;